/**
 * PDP Accessory Block — "Frequently Bundled With" inline bundle.
 *
 * Add-ons follow the lift's delivery choice:
 *  - delivery add-ons inherit the lift's Pickup/Ship choice (overridable, follow-live);
 *  - freight add-ons add the Pickup variant when the lift is Pickup, or the Ship
 *    variant + a "contact me about shipping" acknowledgment when the lift is Ship
 *    (and are appended to the freight quote notes if the customer requests a quote).
 *
 * Checking add-ons updates a live "Total with add-ons" line; the page's own Add to
 * Cart adds the product + checked add-ons together (see custom.js → customAddToCart,
 * which reads [data-pdp-acc-addable] and the per-row data-pdp-acc-needs-ack flag).
 *
 * Every control is data-* only (no name=), so nothing here is submitted with the
 * product form it lives inside.
 */
(function () {
  'use strict';

  var block = document.querySelector('[data-pdp-acc-block]');
  if (!block) return;

  function slice(nl) { return Array.prototype.slice.call(nl); }
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var cards   = slice(block.querySelectorAll('[data-pdp-acc-addable]'));
  var totalEl = block.querySelector('[data-pdp-acc-total]');
  var labelEl = block.querySelector('[data-pdp-acc-total-label]');
  var valueEl = block.querySelector('[data-pdp-acc-total-value]');

  // Main product variant prices (cents), keyed by variant id.
  var mainPrices = {};
  try { var mp = block.querySelector('[data-pdp-acc-main-prices]'); if (mp) mainPrices = JSON.parse(mp.textContent || '{}'); } catch (e) {}
  var firstMainPrice = 0;
  for (var k in mainPrices) { if (mainPrices.hasOwnProperty(k)) { firstMainPrice = mainPrices[k]; break; } }

  var variantSelection = document.querySelector('[data-variant-selection]');
  var form = block.closest('form[data-product-form]') || document.querySelector('form[data-product-form]');
  var qtyInput = document.querySelector('.quantity-selector__input');

  // Lift delivery context (from the mgs-delivery snippet, if the lift has a Delivery Option).
  var deliveryRoot = document.querySelector('[data-mgs-delivery-root]');
  var deliveryMap = {};
  var PICKUP = 'Warehouse Pickup', SHIP = 'Ship to My Address';
  if (deliveryRoot) {
    PICKUP = deliveryRoot.getAttribute('data-pickup-value') || PICKUP;
    SHIP   = deliveryRoot.getAttribute('data-ship-value') || SHIP;
    try { var dm = deliveryRoot.querySelector('[data-mgs-delivery-map]'); if (dm) deliveryMap = JSON.parse(dm.textContent || '{}'); } catch (e) {}
  }

  function mainVariantId() {
    var id = variantSelection ? variantSelection.getAttribute('variant') : null;
    if ((!id || id === 'not-selected') && form) { var el = form.querySelector('[name="id"]'); if (el) id = el.value; }
    return id;
  }
  function liftDeliveryValue() {
    if (!deliveryRoot) return null;
    var id = mainVariantId();
    return (id != null && deliveryMap[id] != null) ? deliveryMap[id] : null;
  }
  function mainUnitPrice() { var id = mainVariantId(); return (id != null && mainPrices[id] != null) ? mainPrices[id] : firstMainPrice; }
  function mainQty() { var q = qtyInput ? parseInt(qtyInput.value, 10) : 1; return (q && q > 0) ? q : 1; }

  function isChecked(card) { var cb = card.querySelector('[data-pdp-acc-checkbox]'); return !!(cb && cb.checked); }
  function selectedOption(card) { var s = card.querySelector('[data-pdp-acc-select]'); return s && s.options[s.selectedIndex] ? s.options[s.selectedIndex] : null; }

  function rowPrice(card) {
    if (card.getAttribute('data-pdp-acc-kind') === 'freight') {
      // a checkable freight row is always in Pickup mode (Ship rows are hidden)
      var p = parseInt(card.getAttribute('data-pickup-price'), 10);
      if (p) return p;
      return parseInt(card.getAttribute('data-default-price'), 10) || 0;
    }
    var opt = selectedOption(card);
    if (opt) return parseInt(opt.getAttribute('data-price'), 10) || 0;
    return parseInt(card.getAttribute('data-default-price'), 10) || 0;
  }

  // ---- freight rows: addable (Pickup variant) when the lift is Pickup; HIDDEN when the lift
  //      ships — a freight Ship needs the per-product quote flow on its own page, so we don't
  //      inline it here. Auto-unchecks so a hidden row can never reach the cart. ----
  function applyFreightMode(card) {
    var isShip = (liftDeliveryValue() === SHIP);
    var pickupVid = card.getAttribute('data-pickup-vid');
    var cb = card.querySelector('[data-pdp-acc-checkbox]');
    if (isShip) {
      if (cb && cb.checked) { cb.checked = false; card.classList.remove('is-selected'); }
      card.hidden = true;
      return;
    }
    card.hidden = false;
    if (cb && pickupVid) cb.setAttribute('data-variant-id', pickupVid);
    card.removeAttribute('data-pdp-acc-needs-ack');
    var noteEl = card.querySelector('[data-pdp-acc-note]');
    if (noteEl) noteEl.textContent = '';
    var pp = card.getAttribute('data-pickup-price');
    var priceEl = card.querySelector('[data-pdp-acc-price]');
    if (priceEl && pp && parseInt(pp, 10)) priceEl.textContent = money(pp);
  }

  // ---- delivery add-on inherits the lift's choice (until manually overridden) ----
  function applyInheritance(card) {
    if (card.getAttribute('data-pdp-acc-overridden') === '1') return;
    var liftVal = liftDeliveryValue();
    if (!liftVal) return;
    var sel = card.querySelector('[data-pdp-acc-select]');
    if (!sel) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].getAttribute('data-delivery') === liftVal) {
        if (sel.selectedIndex !== i) { sel.selectedIndex = i; updateRowFromSelect(card); }
        return;
      }
    }
  }

  function updateRowFromSelect(card) {
    var opt = selectedOption(card);
    var priceEl = card.querySelector('[data-pdp-acc-price]');
    var compEl  = card.querySelector('[data-pdp-acc-compare]');
    if (priceEl && opt) priceEl.textContent = money(opt.getAttribute('data-price'));
    if (compEl && opt) {
      var c = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      var p = parseInt(opt.getAttribute('data-price'), 10) || 0;
      compEl.textContent = (c > p) ? money(c) : '';
    }
    var cb = card.querySelector('[data-pdp-acc-checkbox]');
    if (cb && opt) cb.setAttribute('data-variant-id', opt.value);
  }

  // Flag rows whose chosen variant is a Warehouse Pickup delivery variant, so the add
  // (custom.js) inherits the lift's chosen "Warehouse Pickup Location" onto them. Free/
  // finish add-ons (no delivery axis) are never flagged — they ship, not pickup.
  function syncPickupFlag(card) {
    var kind = card.getAttribute('data-pdp-acc-kind');
    var isPickup = false;
    if (kind === 'freight') {
      isPickup = !card.hidden; // a visible freight row is in Pickup mode
    } else if (kind === 'delivery') {
      var opt = selectedOption(card);
      isPickup = !!(opt && opt.getAttribute('data-delivery') === PICKUP);
    }
    if (isPickup) card.setAttribute('data-pdp-acc-pickup', '1');
    else card.removeAttribute('data-pdp-acc-pickup');
  }

  function recompute() {
    if (!totalEl) return;
    var n = 0, accSum = 0;
    cards.forEach(function (card) { if (isChecked(card)) { n += 1; accSum += rowPrice(card); } });
    if (n === 0) { totalEl.setAttribute('hidden', ''); return; }
    totalEl.removeAttribute('hidden');
    if (labelEl) labelEl.textContent = 'Total with ' + n + (n === 1 ? ' add-on:' : ' add-ons:');
    if (valueEl) valueEl.textContent = money(mainUnitPrice() * mainQty() + accSum);
  }

  // Hide the whole block if nothing is left to show (e.g. an all-freight lift switched to Ship).
  function updateBlockVisibility() {
    if (cards.length === 0) return; // OOS-only block: leave the server-rendered rows visible
    var anyVisible = false;
    for (var i = 0; i < cards.length; i++) { if (!cards[i].hidden) { anyVisible = true; break; } }
    block.style.display = anyVisible ? '' : 'none';
  }

  // Re-apply inheritance / freight visibility whenever the lift's variant changes.
  function onLiftChange() {
    cards.forEach(function (card) {
      var kind = card.getAttribute('data-pdp-acc-kind');
      if (kind === 'freight') applyFreightMode(card);
      else if (kind === 'delivery') applyInheritance(card);
      syncPickupFlag(card);
    });
    updateBlockVisibility();
    recompute();
  }

  function wireCard(card) {
    var kind = card.getAttribute('data-pdp-acc-kind');
    var cb = card.querySelector('[data-pdp-acc-checkbox]');
    if (cb) cb.addEventListener('change', function () { card.classList.toggle('is-selected', cb.checked); recompute(); });

    var sel = card.querySelector('[data-pdp-acc-select]');
    if (sel) sel.addEventListener('change', function () {
      if (kind === 'delivery') card.setAttribute('data-pdp-acc-overridden', '1'); // manual choice stops following the lift
      updateRowFromSelect(card);
      syncPickupFlag(card);
      recompute();
    });

    card.addEventListener('click', function (e) {
      if (e.target.closest('a, select, input, label, option, button, [data-pdp-acc-modal]')) return;
      if (!cb) return;
      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Static (OOS) rows: nothing interactive.

  cards.forEach(wireCard);
  onLiftChange(); // sets initial freight modes + inheritance + total

  // ---- "Learn more" info popups ----
  // Portal each modal to <body> so position:fixed covers the viewport even when an
  // ancestor (theme section / product form) has a transform that would otherwise trap
  // it — which on mobile made the popup size to the page instead of the screen.
  function closeModal(modal) { if (!modal) return; modal.setAttribute('hidden', ''); document.body.style.overflow = ''; }
  function openModal(modal) {
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var c = modal.querySelector('.pdp-acc-modal__close');
    if (c) { try { c.focus(); } catch (e) {} }
  }
  cards.forEach(function (card) {
    var modal = card.querySelector('[data-pdp-acc-modal]');
    if (!modal) return;
    document.body.appendChild(modal);          // portal out of any transformed ancestor
    card.__accModal = modal;
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdp-acc-modal-close]')) { e.preventDefault(); closeModal(modal); }
    });
  });
  block.addEventListener('click', function (e) {
    var learn = e.target.closest('[data-pdp-acc-learn]');
    if (!learn) return;
    e.preventDefault();
    var card = learn.closest('[data-pdp-acc-card]');
    openModal(card && card.__accModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-pdp-acc-modal]:not([hidden])');
    if (open) closeModal(open);
  });

  if (variantSelection && window.MutationObserver) {
    new MutationObserver(onLiftChange).observe(variantSelection, { attributes: true, attributeFilter: ['variant'] });
  }
  document.addEventListener('variant:changed', onLiftChange);
  if (qtyInput) { qtyInput.addEventListener('input', recompute); qtyInput.addEventListener('change', recompute); }
})();
